import adapter from 'webrtc-adapter/out/adapter'
import { mergeAllWith, isArray } from 'lodash/fp'

// TODO: This function was copied from Kandy, we should eventually create a common project that
// can contain all of these utils that are useful in multiple packages.

/**
 * Deeply merges the values of multiple objects. Objects on the left receive the values from objects on their right.
 * Unlike lodash's default merge behavior this doesn't merge arrays.
 *
 * @name mergeValues
 * @param {...Object} objects - Objects to merge
 * @return {Object} A new object containing the merged values.
 */
export function mergeValues (...objects) {
  return mergeAllWith((leftValue, rightValue) => {
    // Overwrite the default behavior of lodash's merge for arrays and simply
    // clobber what's on the left so we don't end up with merged arrays.
    if (isArray(leftValue)) {
      return rightValue
    }
  }, objects)
}

export function makeSafeForCSS (name) {
  if (!name) {
    return name
  } else {
    return name.replace(/[^a-z0-9]/g, '')
  }
}

/**
 * @returns The browser details as provided by webrtc-adapter
 */
export function getBrowserDetails () {
  return adapter.browserDetails
}
